// HUB-UI: all ported grids/edit modals now share the customer-facing Hub chrome.
// LegacyHubFrame preserves the legacy Redux provider for page content while the header
// and permission-driven workspace menus read the Platform session provider.
import type { FC, ReactNode } from 'react';
import { LegacyHubFrame } from '../../../features/hub/HubLayout';
const BasicCli: FC<{ children?: ReactNode }> = ({ children }) => <LegacyHubFrame>{children}</LegacyHubFrame>;
export default BasicCli;
